import { Button, Group, MultiSelect, Stack } from '@mantine/core';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { GpSurfacesMapOrganization } from '../../../lib/types/gp-surfaces-map';

import { useColFilter, useColFilters } from '@data-access';

type GpSurfacesMapFiltersProps = {
  filterName: string;
  organizations: GpSurfacesMapOrganization[];
};

export const GpSurfacesMapFilters: FC<GpSurfacesMapFiltersProps> = ({
  filterName,
  organizations,
}) => {
  const { t } = useTranslation();
  const [organizationFilter, setOrganizationFilter] = useColFilter<string[]>(
    'gpSurfacesMap',
    filterName,
  );
  const [, , resetFilters] = useColFilters('gpSurfacesMap');

  return (
    <Stack gap="sm">
      <MultiSelect
        comboboxProps={{ withinPortal: false }}
        data={organizations.map((organization) => ({
          value: organization.id.toString(),
          label: organization.name,
        }))}
        label={t('common.properties.organization')}
        onChange={(value) => setOrganizationFilter(value)}
        searchable
        value={(organizationFilter as string[] | null | undefined) ?? []}
      />
      <Group justify="flex-end">
        <Button onClick={() => resetFilters()} variant="subtle">
          {t('common.reset')}
        </Button>
      </Group>
    </Stack>
  );
};
